export enum TermsEnum {
  PRO_SELLERS_TERMS = 1,
  MY_AGREEMENTS = 2,
}
